/* Osmanlı Doğal Taş — Rüya Tabiri · 3B gece sahnesi
   ------------------------------------------------------------------
   İlk sürümde arka plan düz CSS gradyanı + 2B nokta yıldızlardı; ekran
   analizinde sayfanın %75'i 17-33 parlaklık aralığında, yatay değişimi
   sıfır çıktı — yani görsel olarak ölü bir alan. Burada gerçek derinlik
   kuruluyor:
     · perspektif projeksiyonlu yıldız alanı (z ekseni, f = d/(d+z))
     · yavaş ilerleyen kamera → yıldızlar büyüyerek yaklaşır
     · dönen gece kubbesi: takımyıldız düğümleri + aralarındaki hatlar
     · iki kayan sis (nebula) katmanı — asıl derinlik hissi buradan gelir
   WebGL YOK: tema genelinde 2B canvas + elle projeksiyon kullanılıyor
   (numeroloji küresi, çakra anatomisi aynı yöntemle çizildi). */
(function () {
  "use strict";
  var kok = document.getElementById("odtRuya");
  var c = document.getElementById("ryaYildiz");
  if (!kok || !c) return;
  var x = c.getContext("2d", { alpha: true });
  if (!x) return;

  var azHareket = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var G = 0, Y = 0, o = 1;          // genişlik, yükseklik, piksel oranı
  var yildiz = [], dugum = [], hat = [], sis = [], onceG = 0, onceY = 0;
  var D = 620;                       // projeksiyon derinliği
  var aci = 0, sonKare = 0;

  function rnd(a, b) { return a + Math.random() * (b - a); }

  function kur() {
    o = Math.min(window.devicePixelRatio || 1, 2);
    G = kok.offsetWidth; Y = kok.offsetHeight;
    c.width = Math.round(G * o); c.height = Math.round(Y * o);
    c.style.width = G + "px"; c.style.height = Y + "px";
    x.setTransform(o, 0, 0, o, 0, 0);

    /* --- derinlikli yıldız alanı (BİR KEZ üretilir) --- */
    var n = Math.max(150, Math.min(420, Math.round(G * Y / 5200)));
    if (yildiz.length) {                      // yeniden boyutlandırma: yerinde kalsınlar
      for (var q = 0; q < yildiz.length; q++) {
        yildiz[q].x = yildiz[q].x / (onceG || G) * G;
        yildiz[q].y = yildiz[q].y / (onceY || Y) * Y;
      }
      onceG = G; onceY = Y;
      return kubbeSis();
    }
    onceG = G; onceY = Y;
    for (var i = 0; i < n; i++) {
      yildiz.push({
        x: rnd(-G, G), y: rnd(-Y, Y), z: rnd(20, D),
        r: rnd(.6, 1.9), p: rnd(.55, .95), h: 0,
        s: Math.random() < .16 ? "#E3C88A" : (Math.random() < .3 ? "#BFD4FF" : "#FFFFFF")
      });
    }

    kubbeSis();
  }

  function kubbeSis() {
    /* --- gece kubbesi: küre yüzeyine dağılmış düğümler --- */
    dugum = []; hat = [];
    var m = G < 640 ? 16 : 26, R = Math.min(G, Y) * (G < 640 ? .62 : .46);
    for (var j = 0; j < m; j++) {
      var u = Math.acos(1 - 2 * (j + .5) / m);      // eşit dağılım
      var v = Math.PI * (1 + Math.sqrt(5)) * j;
      dugum.push({ X: R * Math.sin(u) * Math.cos(v), Y: R * Math.cos(u) * .55, Z: R * Math.sin(u) * Math.sin(v), r: rnd(1.1, 2.4) });
    }
    /* her düğümü en yakın 2 komşusuna bağla — takımyıldız hissi */
    dugum.forEach(function (a, i) {
      var d = dugum.map(function (b, k) { return { k: k, m: (a.X-b.X)*(a.X-b.X)+(a.Y-b.Y)*(a.Y-b.Y)+(a.Z-b.Z)*(a.Z-b.Z) }; })
        .filter(function (t) { return t.k !== i; }).sort(function (p, q) { return p.m - q.m; });
      hat.push([i, d[0].k]); if (d[1]) hat.push([i, d[1].k]);
    });

    /* --- sis katmanları --- */
    sis = [
      { x: G * .26, y: Y * .16, r: Math.max(G, Y) * .52, c: "rgba(112,86,224,", a: .30, hz: .000022, faz: 0 },
      { x: G * .78, y: Y * .40, r: Math.max(G, Y) * .46, c: "rgba(44,104,196,", a: .26, hz: .000031, faz: 2.1 },
      { x: G * .44, y: Y * .70, r: Math.max(G, Y) * .50, c: "rgba(158,92,196,", a: .22, hz: .000018, faz: 4.2 },
      { x: G * .66, y: Y * .92, r: Math.max(G, Y) * .44, c: "rgba(196,150,84,",  a: .14, hz: .000026, faz: 1.2 }
    ];
  }

  function sisCiz(t) {
    sis.forEach(function (s) {
      var kx = s.x + Math.cos(t * s.hz + s.faz) * G * .07;
      var ky = s.y + Math.sin(t * s.hz * 1.4 + s.faz) * Y * .045;
      var gr = x.createRadialGradient(kx, ky, 0, kx, ky, s.r);
      gr.addColorStop(0, s.c + s.a + ")");
      gr.addColorStop(.55, s.c + (s.a * .35) + ")");
      gr.addColorStop(1, s.c + "0)");
      x.fillStyle = gr;
      x.fillRect(0, 0, G, Y);
    });
  }

  function kubbeCiz(t) {
    var cx = G / 2, cy = Y * (G < 640 ? .30 : .34);
    var s = Math.sin(aci), co = Math.cos(aci);
    var iz = dugum.map(function (d) {
      var X = d.X * co - d.Z * s, Z = d.X * s + d.Z * co;
      var f = D / (D + Z + 420);                    // perspektif
      return { x: cx + X * f, y: cy + d.Y * f, f: f, r: d.r * f, z: Z };
    });
    /* hatlar — arkadakiler daha sönük */
    x.lineWidth = 1.2;
    hat.forEach(function (h) {
      var a = iz[h[0]], b = iz[h[1]];
      var op = Math.max(0, Math.min(.34, (a.f + b.f) / 2 - .30));
      if (op <= .01) return;
      x.strokeStyle = "rgba(201,169,97," + op.toFixed(3) + ")";
      x.beginPath(); x.moveTo(a.x, a.y); x.lineTo(b.x, b.y); x.stroke();
    });
    /* düğümler */
    iz.forEach(function (d) {
      var op = Math.max(.08, Math.min(.85, d.f - .18));
      x.globalAlpha = op;
      x.fillStyle = "#E3C88A";
      x.beginPath(); x.arc(d.x, d.y, Math.max(.6, d.r), 0, 6.283); x.fill();
      if (d.f > .62) {                                // öndekilere hafif hâle
        var gr = x.createRadialGradient(d.x, d.y, 0, d.x, d.y, d.r * 7);
        gr.addColorStop(0, "rgba(227,200,138,.26)"); gr.addColorStop(1, "rgba(227,200,138,0)");
        x.fillStyle = gr; x.beginPath(); x.arc(d.x, d.y, d.r * 7, 0, 6.283); x.fill();
      }
    });
    x.globalAlpha = 1;
  }

  function yildizCiz() {
    var cx = G / 2, cy = Y / 2;
    for (var i = 0; i < yildiz.length; i++) {
      var s = yildiz[i];
      /* kamera ilerleyişi kaldırıldı — yıldızlar sabit durur */
      var f = D / (D + s.z);
      var px = cx + s.x * f, py = cy + s.y * f;
      if (px < -20 || px > G + 20 || py < -20 || py > Y + 20) continue;
      /* alfa salınımı yok: nokta ışıklar sabit parlaklıkta durur */
      var r = s.r * f * 1.35;
      x.globalAlpha = s.p * Math.min(1, f * 1.5);
      x.fillStyle = s.s;
      x.beginPath(); x.arc(px, py, r, 0, 6.283); x.fill();
      if (r > 1.9) {                                  // yakın yıldızlara parıltı
        x.globalAlpha *= .32;
        x.beginPath(); x.arc(px, py, r * 3.2, 0, 6.283);
        x.fillStyle = s.s === "#E3C88A" ? "rgba(227,200,138,.16)" : "rgba(190,210,255,.12)";
        x.fill();
      }
    }
    x.globalAlpha = 1;
  }

  /* Metin sütununun arkasını karartır: sahne kenarlarda yaşasın, yazının
     ardında sönsün. Kullanıcı "yazılar okunmuyor" dedi — sahneyi kısmak
     yerine yalnız okuma bandını karartmak ikisini birden çözüyor. */
  function perde() {
    var gen = Math.min(880, G * .74), x0 = (G - gen) / 2;
    var gr = x.createLinearGradient(x0, 0, x0 + gen, 0);
    gr.addColorStop(0, "rgba(6,7,16,0)");
    gr.addColorStop(.18, "rgba(6,7,16,.72)");
    gr.addColorStop(.5, "rgba(6,7,16,.82)");
    gr.addColorStop(.82, "rgba(6,7,16,.72)");
    gr.addColorStop(1, "rgba(6,7,16,0)");
    x.fillStyle = gr;
    x.fillRect(x0, 0, gen, Y);
  }

  function ciz() {
    x.clearRect(0, 0, G, Y);
    sisCiz(0);
    yildizCiz();
    kubbeCiz(0);
    perde();
  }

  kur();
  sonY = Y;
  ciz();

  /* Sonuç ekranı açılınca sayfa uzuyor; canvas onunla birlikte büyümeli.
     DİKKAT: canvas.width'e yazmak düzeni tetikler, bu da ResizeObserver'ı
     yeniden ateşler — ilk sürümde sahne her seferinde sıfırlandığı için
     hiç çizilemedi (canvas doluluğu %0,03). Bu yüzden yalnızca yükseklik
     ANLAMLI değiştiğinde (>80px) yeniden kurulur ve gözlemci canvas'ı
     değil sarmalayıcıyı izler. */
  var z, sonY = Y;
  function tazele() {
    clearTimeout(z);
    z = setTimeout(function () {
      if (Math.abs(kok.offsetHeight - sonY) < 80 && kok.offsetWidth === G) return;
      sonY = kok.offsetHeight;
      kur();
      ciz();
    }, 220);
  }
  window.addEventListener("resize", tazele);
  if (window.ResizeObserver) {
    var ro = new ResizeObserver(tazele);
    var izle = kok.querySelector(".rya-wrap") || kok;
    ro.observe(izle);
  }
})();
